/* A Leading Role - Concierge link and formatting repair.
   Additive on purpose: alr-concierge-live.js owns the chat, and its paint()
   only linkifies URLs that begin with https://. The worker often writes a bare
   "aleadingrole.com/pages/..." with a full stop right after it, which renders
   as dead text a customer has to copy - and copying takes the full stop with
   it, producing a 404. It also sometimes emits markdown, which shows its own
   asterisks.

   Rather than edit that file and risk its scroll and product-card work, this
   watches the panel and repairs the text nodes after they land. It never
   touches product cards or anything already linked. */
(function () {
  'use strict';

  var RE = /\*\*([^*]+)\*\*|\[([^\]]+)\]\(([^)\s]+)\)|((?:https?:\/\/|www\.)[^\s<>"')\]]+|aleadingrole\.com\/[^\s<>"')\]]+)/gi;

  function anchor(url, label) {
    var a = document.createElement('a');
    a.href = /^https?:\/\//i.test(url) ? url : 'https://' + url;
    a.textContent = label;
    a.style.textDecoration = 'underline';
    return a;
  }

  function repair(node) {
    var s = node.nodeValue;
    if (!s || !RE.test(s)) { RE.lastIndex = 0; return false; }
    RE.lastIndex = 0;

    var frag = document.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = RE.exec(s)) !== null) {
      if (m.index > last) frag.appendChild(document.createTextNode(s.slice(last, m.index)));

      if (m[1]) {
        var b = document.createElement('strong');
        b.textContent = m[1];
        frag.appendChild(b);
      } else if (m[2]) {
        frag.appendChild(anchor(m[3], m[2]));
      } else if (m[4]) {
        // A trailing full stop or comma belongs to the sentence, not the URL.
        var clean = m[4].replace(/[.,;:!?)\]]+$/, '');
        frag.appendChild(anchor(clean, clean.replace(/^https?:\/\//i, '')));
        var tail = m[4].slice(clean.length);
        if (tail) frag.appendChild(document.createTextNode(tail));
      }
      last = RE.lastIndex;
    }
    if (last < s.length) frag.appendChild(document.createTextNode(s.slice(last)));

    node.parentNode.replaceChild(frag, node);
    return true;
  }

  function sweep(el) {
    if (!el || el.nodeType !== 1) return;
    if (el.getAttribute('data-alr-linked') === '1') return;

    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var todo = [];
    var n;
    while ((n = walker.nextNode())) {
      // leave product cards and existing links alone
      if (n.parentElement && n.parentElement.closest('a, .c-prod')) continue;
      todo.push(n);
    }
    var changed = false;
    for (var i = 0; i < todo.length; i++) {
      if (repair(todo[i])) changed = true;
    }
    el.setAttribute('data-alr-linked', '1');

    // The panel pins itself to the bottom; a reflow can unpin it.
    if (changed) {
      var box = document.getElementById('c-msgs');
      if (box) box.scrollTop = box.scrollHeight;
    }
  }

  function sweepAll() {
    var box = document.getElementById('c-msgs');
    if (!box) return;
    var bubbles = box.querySelectorAll('.c-msg');
    for (var i = 0; i < bubbles.length; i++) sweep(bubbles[i]);
  }

  function watch() {
    var box = document.getElementById('c-msgs');
    if (!box) { setTimeout(watch, 500); return; }

    sweepAll();
    new MutationObserver(function () {
      // The reply arrives by rewriting the placeholder bubble, so re-check
      // everything rather than only newly added nodes.
      var bubbles = box.querySelectorAll('.c-msg');
      for (var i = 0; i < bubbles.length; i++) {
        var el = bubbles[i];
        if (el.textContent && el.textContent.indexOf('…') === -1) {
          el.removeAttribute('data-alr-linked');
          sweep(el);
        }
      }
    }).observe(box, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
